<template>
	<div class="h-screen flex w-full bg-img">
		<div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row">
						<div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
							<img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
						</div>

						<div
							id="reset-step-two"
							class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
						>
							<div class="p-8">
								<div class="vx-card__title mb-8">
									<h4 class="mb-4">
										{{ $t("ResetPassword.TitleReset") }}
									</h4>
									<vs-alert
										id="alert"
										class="mb-6 overflow-auto"
										color="success"
										:title="$t('ResetPassword.VerificationCode.Title')"
										:active.sync="alertCode"
										closable
										icon-pack="feather"
										close-icon="icon-x"
									>
										<span>
											{{ $t("ResetPassword.VerificationCode.Text1") }}
										</span>
										<span
											class="text-inherit underline"
											@click="handleBack"
											style="cursor: pointer"
										>
											{{ $t("ResetPassword.VerificationCode.Text2") }}
										</span>
									</vs-alert>
								</div>
								<vs-input
									type="text"
									label-placeholder="Código"
									v-model="code"
									class="w-full"
									v-validate="'required|alpha_num|min:6|max:6'"
									data-vv-validate-on="blur"
									name="code"
								/>
								<span class="text-danger text-sm" v-show="errors.has('code')">{{
									errors.first("code")
								}}</span>
								<div class="password-field">
									<vs-input
										:type="keyType"
										label-placeholder="Contraseña"
										v-model="password"
										class="w-full mb-8 mt-base"
										:danger="!meetPasswordStandard"
										danger-text="La contraseña debe ser de 8 a 15 caracteres y tener: 1 minúscula, 1 mayúscula, 1 número y 1 carácter especial."
									/>

									<div class="eye-password" @click="SeePassword()">
										<vs-icon icon-pack="feather" :icon="keyIcon" size="small"></vs-icon>
									</div>
								</div>
								<div class="password-field">
									<vs-input
										:type="keyTypeConfirm"
										label-placeholder="Confirmar Contraseña"
										v-model="passwordConfirm"
										class="w-full mb-8"
										:danger="!meetPasswordStandardConfirm || passwordsMatches === false"
										:danger-text="danger_text"
									/>
									<div class="eye-password" @click="SeePasswordConfirm()">
										<vs-icon icon-pack="feather" :icon="keyIconConfirm" size="small"></vs-icon>
									</div>
								</div>

								<div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
									<vs-button
										type="border"
										to="/pages/forgot-password"
										class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
										>{{ $t("Back") }}</vs-button
									>
									<vs-button
										class="w-full sm:w-auto"
										:disabled="
											disabledReset || errors.any() || !passwordsMatches || code.length <= 0
										"
										@click="resetPassword()"
										>{{ $t("Submit") }}</vs-button
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import Api from "@/helpers/api";
import {Validator} from "vee-validate";

export default {
	data() {
		return {
			email: "",
			password: "",
			passwordConfirm: "",
			code: "",
			meetPasswordStandard: true,
			meetPasswordStandardConfirm: true,
			passwordsMatches: null,
			steps: {
				one: true,
				two: false,
			},
			disabledReset: true,
			keyType: "password",
			keyTypeConfirm: "password",
			keyIcon: "icon-eye",
			keyIconConfirm: "icon-eye",
			passwordConfirmDangerText: "",
			DANGER_TEXT_1:
				"La contraseña debe ser de 8 a 15 caracteres y tener: 1 minúscula, 1 mayúscula, 1 número y 1 carácter especial.",
			DANGER_TEXT_2: "Las contraseñas no coinciden.",
			alertCode: true,
		};
	},
	computed: {
		danger_text: {
			get() {
				return this.passwordConfirmDangerText;
			},
			set(val) {
				this.passwordConfirmDangerText = val;
			},
		},
	},
	watch: {
		password(newval, oldval) {
			if (newval.length > 0) {
				this.validatePasswod(newval);
			} else {
				this.meetPasswordStandard = true;
				this.disabledReset = true;
			}
		},
		passwordConfirm(newval, oldval) {
			if (newval.length > 0) {
				this.validatePasswodConfirm(newval);
			} else {
				this.meetPasswordStandardConfirm = true;
				this.disabledReset = true;
			}
		},
	},
	methods: {
		validatePasswod(password) {
			const reg = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/;
			this.meetPasswordStandard = reg.test(password);
			if (this.meetPasswordStandard) {
				this.disabledReset = false;
			}
		},
		validatePasswodConfirm(password) {
			const reg = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/;
			this.meetPasswordStandardConfirm = reg.test(password);
			if (this.meetPasswordStandardConfirm) {
				if (this.password === this.passwordConfirm) {
					this.passwordsMatches = true;
				} else {
					this.passwordsMatches = false;
					this.danger_text = this.DANGER_TEXT_2;
				}
				this.disabledReset = false;
			} else {
				this.passwordsMatches = null;
				this.danger_text = this.DANGER_TEXT_1;
			}
		},
		getCode() {
			let params = {
				email: this.email,
			};

			this.$vs.loading({
				container: "#reset-step-one",
				scale: 0.6,
			});

			Api.post("/recovery/code", params)
				.then((result) => {
					this.steps.one = false;
					this.steps.two = true;
					this.email = "";
					this.$vs.loading.close("#reset-step-one > .con-vs-loading");
				})
				.catch((error) => {
					console.error(error);
				});
		},
		resetPassword() {
			let params = {
				code_recover_pass: this.code,
				new_password: this.password,
			};
			this.$vs.loading();
			Api.post("/recover/password", params)
				.then((result) => {
					this.code = "";
					this.password = "";
					this.steps.one = false;
					this.steps.two = true;
					this.$vs.loading.close();
					this.$vs.notify({
						title: "Felicidades",
						text: "Contraseña configurada con éxito",
						color: "success",
					});
					this.$router.push({name: "page-login"});
				})
				.catch((error) => {
					console.error(error);
					this.$vs.loading.close();
					switch (error.data.reason) {
						case "Code recover pass not exists.":
							this.$vs.notify({
								title: "Código Incorrecto",
								text: "Por favor verifica el código.",
								color: "danger",
							});
							break;

						case "The password is not secure.":
							this.$vs.notify({
								title: "Código Incorrecto",
								text: "Tu contraseña debe ser de mínimo 8 caracteres y debe tener 1 mayúscula, 1 minúscula, 1 número y un carácteres especial.",
								color: "danger",
							});
							break;

						default:
							this.code = "";
							this.password = "";
							this.$vs.notify({
								title: "Atención",
								text: "El código ha expirado o hubo un error al configurar tu contraseña, intentalo de nuevo.",
								color: "danger",
							});
							this.steps.one = true;
							this.steps.two = false;
							break;
					}
				});
		},
		SeePassword() {
			if (this.keyType === "password") {
				this.keyType = "text";
				this.keyIcon = "icon-eye-off";
			} else {
				this.keyType = "password";
				this.keyIcon = "icon-eye";
			}
		},
		SeePasswordConfirm() {
			if (this.keyTypeConfirm === "password") {
				this.keyTypeConfirm = "text";
				this.keyIconConfirm = "icon-eye-off";
			} else {
				this.keyTypeConfirm = "password";
				this.keyIconConfirm = "icon-eye";
			}
		},
		handleBack() {
			this.$router.go(-1);
		},
	},
	mounted() {
		const dict = {
			custom: {
				code: {
					required: this.$t("LoginModule.CodeErrorRquired"),
					max: this.$t("LoginModule.CodeErrorGreater"),
					min: this.$t("LoginModule.CodeErrorToShort"),
					alpha_num: this.$t("LoginModule.CodeErrorAlphaNum"),
				},
			},
		};
		// register custom messages
		Validator.localize("en", dict);
	},
};
</script>
<style>
.password-field {
	position: relative;
}

.eye-password {
	position: absolute;
	top: 4px;
	right: 4px;
	background: transparent;
	height: 30px;
	width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
</style>
